// filepath: /mnt/d/Seafile/Projects/pre-stage/client/utils.ts

/**
 * Generates a default email address for a user based on their username and role
 * @param username User's username
 * @param role User's role (admin, teacher, or student)
 * @returns The default email address
 */
export const getDefaultEmail = (username: string, role: string): string => {
  if (role === 'teacher' || role === 'admin') {
    return `${username}@unistra.fr`;
  } else {
    return `${username}@etu.unistra.fr`;
  }
};